module.exports = __webpack_public_path__ + "img/morgan1.14729339.jpg";